<main *ngIf="!isPreLogin && authMode=='REPO' " class="fids-content fids-login-main login-min-ht"
    style="background-color: #F6F6F6">
    <div class="container-fluid fids-login-pos fids-mdc-font">
        <div *ngIf="errorMsg && messageVisible && !isSessionExpired && !isInvalidBrowserSession" class="row logout-alert-bar">
                <mat-card class="logout-alert-card card-width1" appearance="outlined">
                    <div class="logout-alert-content">
                        <mat-icon color="warn" style="margin-top: 4px; padding: 1px 6px;">error_outline</mat-icon>
                        <span class="logout-alert-text">{{errorMsg}}</span>
                        <button mat-icon-button class="logout-alert-close" (click)="closeLogoutMessage()"
                            aria-label="Close">
                            <mat-icon style="margin-top: 4px;">close</mat-icon>
                        </button>
                    </div>
                </mat-card>
            </div>
             <div *ngIf="isSessionExpired" class="row logout-alert-bar">
                <mat-card class="logout-alert-card card-width1" appearance="outlined">
                    <div class="logout-alert-content">
                        <mat-icon color="warn" style="margin-top: 4px; padding: 1px 6px;">error_outline</mat-icon>
                        <span class="logout-alert-text">{{sessionExpiredMessage}}</span>
                        <button mat-icon-button class="logout-alert-close" (click)="closeLogoutMessage()"
                            aria-label="Close">
                            <mat-icon style="margin-top: 4px;">close</mat-icon>
                        </button>
                    </div>
                </mat-card>
            </div>
            <div *ngIf="isInvalidBrowserSession && !isSessionExpired" class="row logout-alert-bar">
                <mat-card class="logout-alert-card card-width1" appearance="outlined">
                    <div class="logout-alert-content">
                        <mat-icon color="warn" style="margin-top: 4px; padding: 1px 6px;">error_outline</mat-icon>
                        <span class="logout-alert-text">{{invalidBrowserSessionMessage}}</span>
                        <button mat-icon-button class="logout-alert-close" (click)="closeLogoutMessage()"
                            aria-label="Close">
                            <mat-icon style="margin-top: 4px;">close</mat-icon>
                        </button>
                    </div>
                </mat-card>
            </div>
        <div class="row justify-content-center" style="margin-bottom: 7%">
            <div class="mdc-card mdc-elevation--z4 fids-login-card">
                <div class="material-form-controls">
                    <form [formGroup]="form" (ngSubmit)="onSubmit()" validateOnSubmit autocomplete="off">
                        <div class="row border-b-dash">
                            <div class="col-sm-2 m-b-20">
                                <img class="fids-login-logo" src="./assets/images/EY-logo-dark.png" alt="logo">
                            </div>
                            <div class="col-sm-8 fids-login-header">
                                <h2 class="mdc-typography mdc-typography--headline5 text-align-center">
                                    {{applicationName}}
                                </h2>
                            </div>
                        </div>
                        <div class="row m-t-20">
                            <div class="col-sm-12 m-b-10">
                                <label class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material">

                                    <input matInput class="mdc-text-field__input  input-aligner txt-spacer" type="text"
                                        aria-labelledby="my-label-id" autocomplete="off" formControlName="username"
                                        required autofocus>
                                    <span class="mdc-floating-label  minus-margin" id="my-label-id">
                                        Username
                                    </span>
                                    <div class="mdc-line-ripple"></div>
                                </label>
                            </div>

                            <div class="col-sm-12 m-b-10">
                                <div>
                                    <label
                                        class="mdc-text-field mdc-text-field--fullwidth fids-line-ripple text-material">
                                        <input matInput class="mdc-text-field__input  input-aligner txt-spacer" type="password"
                                            required minlength="7" autocomplete="off" aria-label="Full-Width Text Field"
                                            formControlName="currentSecureKey" aria-controls="my-helper-id"
                                            aria-describedby="my-helper-id" aria-labelledby="my-label-id1">
                                        <span class="mdc-floating-label minus-margin" id="my-label-id1">
                                            Password
                                        </span>
                                        <div class="mdc-line-ripple"></div>
                                    </label>
                                </div>
                            </div>
                            <div class="form-action-buttons m-b-10 m-t-20 col-sm-12">
                                <button class="mdc-button mdc-button--outlined btn-capitalize ripple-material pull-left"
                                    type="reset"
                                    [disabled]="!(form.controls.username.value || form.controls.currentSecureKey.value) || isSessionExpired || isInvalidBrowserSession">
                                    <span class="mdc-button__ripple"></span> Reset
                                </button>
                                <button
                                    class="mdc-button mdc-button--unelevated btn-capitalize ripple-material pull-right"
                                    type="submit" [disabled]="!form.valid || isSessionExpired || isInvalidBrowserSession">
                                    <span class="mdc-button__ripple"></span> Login
                                </button>
                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</main>
<main *ngIf="!isPreLogin && authMode=='SAML_AZURE' && !inProgress" class="fids-content fids-login-main login-min-ht"
    style="background-color: #F6F6F6">
    <div class="container-fluid fids-login-pos fids-mdc-font">
        <div *ngIf="true && errorMsg && !isSessionExpired && !isInvalidBrowserSession" class="row logout-alert-bar">
            <mat-card class="logout-alert-card card-width2" appearance="outlined">
                <div class="logout-alert-content">
                    <mat-icon color="warn" style="margin-top: 4px; padding: 1px 6px;">error_outline</mat-icon>
                    <span class="logout-alert-text">{{errorMsg}}</span>
                    <button mat-icon-button class="logout-alert-close" (click)="closeLogoutMessage()" aria-label="Close">
                        <mat-icon style="margin-top: 4px;">close</mat-icon>
                    </button>
                </div>
            </mat-card>
        </div>
      
        <div class="container-fluid fids-login-pos fids-mdc-font">
            <div class="col-md-6 mx-auto justify-content-center" style="margin-bottom: 1%;margin-top: 0%;">
                <div *ngIf="isSessionExpired" class="row1 mx-auto logout-alert-bar">
                    <mat-card class="logout-alert-card card-width21" appearance="outlined">
                        <div class="logout-alert-content">
                            <mat-icon color="warn" style="margin-top: 4px; padding: 1px 6px;">error_outline</mat-icon>
                            <span class="logout-alert-text">{{sessionExpiredMessage}}</span>
                            <button mat-icon-button class="logout-alert-close" (click)="closeLogoutMessage()" aria-label="Close">
                                <mat-icon style="margin-top: 4px;">close</mat-icon>
                            </button>
                        </div>
                    </mat-card>
                </div>
            <div *ngIf="isInvalidBrowserSession && !isSessionExpired" class="row1 mx-auto logout-alert-bar">
                <mat-card class="logout-alert-card card-width21" appearance="outlined">
                    <div class="logout-alert-content">
                        <mat-icon color="warn" style="margin-top: 4px; padding: 1px 6px;">error_outline</mat-icon>
                        <span class="logout-alert-text">{{invalidBrowserSessionMessage}}</span>
                        <button mat-icon-button class="logout-alert-close" (click)="closeLogoutMessage()"
                            aria-label="Close">
                            <mat-icon style="margin-top: 4px;">close</mat-icon>
                        </button>
                    </div>
                </mat-card>
            </div>
                <div class="mdc-card mdc-elevation--z4 fids-login-card" style="border-radius: 10px !important;">
                    <div style="align-items: center; ">
                        <div class="material-form-controls login-card ">
                            <div class="containerimg simple-card">
                                <img class="fids-login-logo"
                                    style="width: 115px; height: 56px; object-fit: contain; margin-top: 2px;"
                                    src="./assets/images/EY_Logo_Beam_Tag_Horizontal_RGB_OffBlack_Yellow.png"
                                    alt="EY Logo">
                                <div class="container_felx">
                                    <div class="item2 containerFOrmiddel" *ngIf="authMode=='SAML_AZURE'">
                                        <div class="item_logo">

                                        </div>
                                        <div class="item_name">
                                            @if (welcomeScreenTitle !== undefined) {
                                            <div class="welcome-screen-title">
                                                {{ welcomeScreenTitle }}{{applicationName}}
                                            </div>
                                            }
                                            @if (welcomeScreenSubtitle !== undefined) {
                                            <div class="welcome-screen-subtitle">
                                                {{ welcomeScreenSubtitle }}
                                            </div>
                                            }

                                        </div>

                                        <div class="item ">
                                            <button
                                                style="font-size: 14px; font-family: EYInterstate, sans-serif !important; font-weight: bold;"
                                                class="mdc-button mdc-button--raised mdc-button--sharp ripple-material"
                                                title="Sign In" (click)="redirectToLogin()" [disabled]="isSessionExpired || isInvalidBrowserSession">
                                                Sign In
                                            </button>

                                        </div>

                                        <div class="itemMsg " style="           
                                                color: red;text-align: center;">

                                            <h6>{{CurrentErrorMsg}}</h6>
                                        </div>
                                        <div class="row logindesc" style="padding: 0px 10px 0px 10px;">
                                            EY refers to the global organization and may refer to one or more of the
                                            member
                                            firms of Ernst & Young
                                            Global Limited, each of which is a separate legal entity. Ernst & Young
                                            Global
                                            Limited, a UK company limited
                                            by guarantee, does not provide services to clients.
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</main>